export const emitSelected = event => ({
    type: 'EMIT_SELECTED',
    event,
});

export const updateListener = listener => ({
    type: 'UPDATE_LISTENER',
    listener,
});
